<template>
  <el-dialog
    title="部门树"
    :visible.sync="show"
    :center="true"
    width="600px"
    v-loading="loading">
    <div style="width: 100%; height: 520px; min-height: 400px; ">
      <el-tree
        node-key="id"
        show-checkbox
        default-expand-all
        :data="propData"
        :check-strictly="true"
        :props="tree.props"
        class="filter-tree"
        @check="checkChange"
        ref="tree" style=" height: 100%; overflow-y: auto;">
    </el-tree>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="show = false">取消</el-button>
      <el-button type="primary" @click="sureFn">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "DepTree",
  components: {},
  props: ["propData"],
  data() {
    return {
      show: false,
      loading: false,
      tree: {
        boxShow: false,
        data: this.propData,
        props: {
        children: 'children',
        label: 'name'
        },
        backArr: {},
      },
      check: {
        data: []
      }
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // 显示弹框
    dialogShow () {
      this.show = true;
      // this.loading = true;
      // setTimeout(() => {

      //   this.loading = false;
      // }, 500);
    },

    // 选择中
    checkChange: function (data,checked) {
      if( checked.checkedKeys[0] ){
        this.$refs.tree.setCheckedNodes([]);
        this.$refs.tree.setCheckedNodes([data]);
        this.check.data = data;
      }else {
        this.$refs.tree.setCheckedNodes([]);
        this.check.data = null;
      }

    },

    // 确定选中
    sureFn () {
      this.show = false;
      this.$emit("backFn", this.check.data);
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
